import React from 'react';
import { Heart, Award, Leaf } from 'lucide-react';

const WelcomeModern = () => {
  return (
    <section id="welcome" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              Benvenuti
            </h2>
            <div className="w-24 h-1 bg-[#7f9e60] mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/images/chi-siamo.jpg"
                  alt="Grano e Sale - Il nostro locale"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              {/* Accent decoration */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#7f9e60]/20 rounded-2xl -z-10"></div>
            </div>

            {/* Right - Content */}
            <div className="space-y-8">
              <div className="inline-block px-6 py-2 bg-[#7f9e60]/10 rounded-full">
                <span className="text-[#7f9e60] font-semibold uppercase tracking-wide text-sm">Dal 2003</span>
              </div>

              <h3 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Un Locale che è Casa
              </h3>

              <p className="text-lg text-gray-700 leading-relaxed">
                <strong>La giovialità che colora il locale si ritrova nella cordialità di coloro che vi lavorano 
                e nella socievolezza di coloro che lo frequentano</strong>, contribuendo ad impreziosire quella 
                linea di affetto e comunicazione che da sempre contraddistingue Grano e Sale.
              </p>

              <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-[#7f9e60]">
                <p className="text-gray-700 italic mb-3">
                  "Un locale dove tradizione e passione si incontrano ogni giorno"
                </p>
                <div className="flex items-center space-x-2">
                  <div className="flex -space-x-2">
                    <div className="w-10 h-10 rounded-full bg-[#7f9e60] flex items-center justify-center text-white font-bold">M</div>
                    <div className="w-10 h-10 rounded-full bg-[#6a8550] flex items-center justify-center text-white font-bold">M</div>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Massimo Posati & Massimo Pacelli</p>
                    <p className="text-sm text-gray-600">I Responsabili</p>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="grid grid-cols-3 gap-4 pt-4">
                <div className="text-center p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow">
                  <Heart className="w-8 h-8 text-[#7f9e60] mx-auto mb-2" />
                  <p className="text-sm font-semibold text-gray-700">Passione</p>
                </div>
                <div className="text-center p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow">
                  <Award className="w-8 h-8 text-[#7f9e60] mx-auto mb-2" />
                  <p className="text-sm font-semibold text-gray-700">Qualità</p>
                </div>
                <div className="text-center p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow">
                  <Leaf className="w-8 h-8 text-[#7f9e60] mx-auto mb-2" />
                  <p className="text-sm font-semibold text-gray-700">Freschezza</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeModern;
